import { createSelector } from '@reduxjs/toolkit';
import { AppState } from 'store';
import { IProjectState } from './projects.interface';

export const projectsStateSelector = ({ projects }: AppState): IProjectState => projects;

export const getProjectsSelector = createSelector(projectsStateSelector, (projects): IProjectState => projects);

export const getCheckProjectArraySelector = createSelector(
  projectsStateSelector,
  ({ projectCheckArray }) => projectCheckArray,
);

export const getProjectErrorArraySelector = createSelector(
  projectsStateSelector,
  ({ projectErrorArray }) => projectErrorArray,
);

export const getIsFilteredSelector = createSelector(projectsStateSelector, ({ isFiltered }) => isFiltered);

export const getProjectLanguagesSelector = createSelector(
  projectsStateSelector,
  ({ projectLanguages }) => projectLanguages,
);

export const getProjectWorkflowStepsSelector = createSelector(
  projectsStateSelector,
  ({ projectWorkflowSteps }) => projectWorkflowSteps,
);

export const getProjectChangedProductsSelector = createSelector(
  projectsStateSelector,
  ({ changedProducts }) => changedProducts,
);

export const getXTMRequestersForProjectSelector = createSelector(
  projectsStateSelector,
  ({ xtmRequesters }) => xtmRequesters,
);

// eslint-disable-next-line id-length
export const getXTMCustomersForCurrentUserSelector = createSelector(
  projectsStateSelector,
  ({ xtmCustomers }) => xtmCustomers,
);

export const getProjectSearchSelector = createSelector(projectsStateSelector, ({ search }) => search);
